import React from 'react';
import { motion } from 'framer-motion';

const LINK_ANIMATIONS_VARIANTS = {
  visible: { opacity: 1, y: 0 },
  hidden: { opacity: 0, y: -10 }
};

/**
 * @typedef {object} FooterLinkComponentProps
 * @property {string} href
 * @property {string} id
 * @property {string} linkText
 * @property {boolean} [isNewTab]
 */

/**
 * @param {FooterLinkComponentProps} props
 */
const FooterLinkComponent = props => {
  const { href, id, isNewTab, linkText } = props;
  return (
    <motion.a
      transition={{ duration: 0.2 }}
      initial='hidden'
      animate='visible'
      variants={LINK_ANIMATIONS_VARIANTS}
      target={isNewTab ? '_blank' : '_self'}
      href={href}
      id={id}
      className='link'
      rel='noreferrer'>
      <strong>{linkText}</strong>
    </motion.a>
  );
};

export default FooterLinkComponent;
